import { API_HOST_NAME } from "../constants.js";
import useAuthenticatedResources from "../../../useAuthenticatedResources.js";

const useHetznerProjectsResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/cloud/teams/${teamId}/hetzner/projects`;
  return useAuthenticatedResources(url, {}, [
    { name: "metadata", method: "GET", member: true, path: "metadata" },
  ])
}

export default useHetznerProjectsResources;
